/**
 * Pluggable crash-capture registry.
 *
 * ErrorBoundary calls `captureRenderError` when React render errors are caught.
 * Sentry (or any other crash reporter) registers its handler via
 * `registerCrashReporter`. This module lives in utils so neither side depends
 * on the other — breaking the previous utils/sentry -> components/ErrorBoundary
 * upward dependency.
 */

type CrashHandler = (error: Error, componentStack?: string) => void;

let handler: CrashHandler = () => {};

/** Register a handler that receives uncaught React render errors. */
export function registerCrashReporter(fn: CrashHandler): void {
  handler = fn;
}

/** Called by ErrorBoundary to forward the error to the registered handler. */
export function captureRenderError(error: Error, componentStack?: string): void {
  handler(error, componentStack);
}
